import { render, staticRenderFns } from "./CommodityMarketingMaterial.vue?vue&type=template&id=2fdda80b&scoped=true&"
import script from "./CommodityMarketingMaterial.vue?vue&type=script&lang=js&"
export * from "./CommodityMarketingMaterial.vue?vue&type=script&lang=js&"
import style0 from "./CommodityMarketingMaterial.vue?vue&type=style&index=0&id=2fdda80b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdda80b",
  null
  
)

export default component.exports